import React from "react";

export function joinWithLastWord(names, separator, lastWord) {
  let result = names.join(separator);
  const index = result.lastIndexOf(separator);
  if (index !== -1) {
    result = result.substring(0, index) + ' ' + lastWord + ' ' + result.substring(index + 2);
  }
  return result;
}

export function getPlural(nb, noun) {
  if (nb > 1) {
    return <span>{nb} {noun}s</span>
  }
  return <span>{nb} {noun}</span>
}